import React from "react";
import { Phone } from "lucide-react";
import { WhatsAppIcon, TelegramIcon, InstagramIcon } from "./SocialIcons";

const PHONE_RAW = "+420731385947";
const PHONE_DISPLAY = "+420 731 385 947";

const items = [
  {
    Icon: Phone,
    label: "Telefon",
    href: `tel:${PHONE_RAW}`,
    testid: "social-phone",
    title: PHONE_DISPLAY,
  },
  {
    Icon: WhatsAppIcon,
    label: "WhatsApp",
    href: `https://wa.me/${PHONE_RAW.replace("+", "")}`,
    external: true,
    testid: "social-whatsapp",
    title: `WhatsApp ${PHONE_DISPLAY}`,
  },
  {
    Icon: TelegramIcon,
    label: "Telegram",
    href: `https://t.me/${PHONE_RAW}`,
    external: true,
    testid: "social-telegram",
    title: `Telegram ${PHONE_DISPLAY}`,
  },
  {
    Icon: InstagramIcon,
    label: "Instagram",
    href: "https://www.instagram.com/terwiliger_cz/",
    external: true,
    testid: "social-instagram",
    title: "Instagram @terwiliger_cz",
  },
];

const SocialBar = ({ size = "md", showLabels = false }) => {
  const sz = size === "lg" ? 22 : 18;
  const padCls =
    size === "lg"
      ? "w-12 h-12 md:w-14 md:h-14"
      : "w-11 h-11";

  return (
    <ul className="flex flex-wrap gap-2 md:gap-3" data-testid="social-bar">
      {items.map(({ Icon, label, href, external, testid, title }) => {
        const baseCls = `inline-flex items-center justify-center ${padCls} border border-white/10 bg-[#0a0a0a] text-zinc-300 hover:text-[#E5FF00] hover:border-[#E5FF00] transition-colors`;
        const inner = (
          <>
            <Icon size={sz} />
            {showLabels && (
              <span className="ml-2 font-mono-tech text-xs uppercase tracking-[0.2em]">
                {label}
              </span>
            )}
          </>
        );
        return (
          <li key={testid}>
            {href ? (
              <a
                href={href}
                title={title}
                aria-label={title}
                target={external ? "_blank" : undefined}
                rel={external ? "noopener noreferrer" : undefined}
                className={baseCls}
                data-testid={testid}
              >
                {inner}
              </a>
            ) : (
              <span
                title={title}
                aria-label={title}
                className={`${baseCls} cursor-default opacity-70`}
                data-testid={testid}
              >
                {inner}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default SocialBar;
